// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import YouTubePlayer from 'react-player/lib/players/YouTube'

// Internal Dependencies:
// import Posts from './Posts'
import Subscribe from 'components/Subscribe/Subscribe'
import PostCard from 'components/Card/PostCard'

class Know extends React.Component {
	render() {
		return (
			<div>
				<div className="wide-section wide-section-know-a -edge -bg-off-white">
					<div className="c-grid">
						<div className="-column-4">
							<p>
								Knowing Jesus changes everything. Growing closer in our walk with Him impacts every single aspect of our life. We want to encourage you in your journey with Jesus.
								<br />
								Here we have provided various resources, blogs, vlogs and stories that we hope you will find useful. They can be accessed anytime, from anywhere you have the internet. You can use them by yourself or in a group. Feel free to explore our resources, and make sure you have subscribed so we can give you updates when we add anything new.
							</p>
						</div>

						<div className="-column-3">
							<div className="media-player">
								<YouTubePlayer url="https://www.youtube.com/watch?v=ZM3dga2ccA0" controls={ true } />
							</div>
						</div>
					</div>
				</div>

				<div className="wide-section wide-section-know-b -edge -bg-off-white-">
					<p>
						Here are some great resources to get you started. You will find resources that are great for your personal reflection time and/or Bible Discovery Reading, while some resources here work well in a group setting.
					</p>

					<div className="image-links">
						<div className="image-link-wrap">
							<Link to="/discover" className="image-link">
								<div className="-inner">
									<div className="-title">
										<h3>Discover Jesus</h3>
									</div>

									<div className="-image">
										<img src={ `${siteData.images_url}home/prayer.jpg` } alt='' />
									</div>
								</div>
							</Link>
						</div>

						<div className="image-link-wrap">
							<Link to="/experience" className="image-link">
								<div className="-inner">
									<div className="-title">
										<h3>Experience Jesus</h3>
									</div>

									<div className="-image">
										<img src={ `${siteData.images_url}home/sitting.jpg` } alt='' />
									</div>
								</div>
							</Link>
						</div>

						<div className="image-link-wrap">
							<Link to="/share" className="image-link">
								<div className="-inner">
									<div className="-title">
										<h3>Share Jesus</h3>
									</div>

									<div className="-image">
										<img src={ `${siteData.images_url}home/network.jpg` } alt='' />
									</div>
								</div>
							</Link>
						</div>
					</div>
				</div>

				<div className="wide-section wide-section-know-b -edge -bg-off-white">
					<section>
						<p>
							Here are some blogs and vlogs to take your journey a little deeper.
						</p>

						<div className="know-blog-wrap">
							<div className="stories post-cards">
								<div className="cards posts">
									<div className="-inner">
										<PostCard
											url="/blog/discipleshift/"
											imageUrl="/wp-content/uploads/2018/06/hands-together-1024x205.jpg"
											title="Discipleshift"
											date="June 21, 2018"
										/>

										<PostCard
											url=""
											imageUrl=""
											videoUrl="https://www.youtube.com/watch?v=cb6x7laIo6o"
											title=""
											date=""
										/>

										<PostCard
											url=""
											imageUrl=""
											videoUrl="https://www.youtube.com/watch?v=2yABp0ND-jI"
											title=""
											date=""
										/>

										<PostCard
											url=""
											imageUrl=""
											videoUrl="https://www.youtube.com/watch?v=EldJBOXJ2aU"
											title=""
											date=""
										/>

										<PostCard
											url=""
											imageUrl=""
											videoUrl="https://www.youtube.com/watch?v=VHSXqcHZNuk"
											title=""
											date=""
										/>

										<PostCard
											url=""
											imageUrl=""
											videoUrl="https://www.youtube.com/watch?v=ZAjxgDcoN_4"
											title=""
											date=""
										/>

										<PostCard
											url=""
											imageUrl=""
											videoUrl="https://www.youtube.com/watch?v=SzyJW5-tlPU"
											title=""
											date=""
										/>

										<PostCard
											url=""
											imageUrl=""
											videoUrl="https://www.youtube.com/watch?v=Pgysuynywpg"
											title=""
											date=""
										/>

										<PostCard
											url=""
											imageUrl=""
											videoUrl="https://www.youtube.com/watch?v=dmlk148wyO4"
											title=""
											date=""
										/>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>

				<Subscribe text="Enter your name and email to receive our latest blogs and updates:" />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Know )



// WEBPACK FOOTER //
// ./views/main/page/Know.jsx